<div class="documents-tabs-wrapper">
  <!-- Titolo Documenti con sottotitolo Indice sopra i TAB -->
  <div class="documents-main-header">
    <h1 class="docs-main-title">Documenti</h1>
    <p class="docs-index-subtitle">Indice: {{ indexName() }}</p>
  </div>

  <!-- Barra di navigazione dei 3 TAB -->
  <div class="documents-tabs-bar">
    <button 
      class="tab-button" 
      [class.active]="activeTab() === 'to-process'" 
      (click)="selectTab('to-process')">
      <span class="material-symbols-outlined">pending</span>
      <span>Da processare</span>
    </button>
    <button 
      class="tab-button" 
      [class.active]="activeTab() === 'processed'" 
      (click)="selectTab('processed')">
      <span class="material-symbols-outlined">check_circle</span>
      <span>Processati</span>
    </button>
    <button 
      class="tab-button" 
      [class.active]="activeTab() === 'error'" 
      (click)="selectTab('error')">
      <span class="material-symbols-outlined">error</span>
      <span>In errore</span>
    </button>
  </div>

  <!-- Contenuto del TAB attivo -->
  <div class="documents-tab-content">
    @switch (activeTab()) {
      @case ('to-process') {
        <app-to-process [targetIndex]="indexName()" />
      }
      @case ('processed') {
        <app-processed [targetIndex]="indexName()" />
      }
      @case ('error') {
        <app-in-error [targetIndex]="indexName()" />
      }
    }
  </div>
</div>